import React, { MouseEventHandler, useCallback } from 'react'
import { applyEdgeChanges, applyNodeChanges, useReactFlow } from '@xyflow/react'
import { getStepConfig } from '../../step-config'
import { getRemoveNodeMutations } from '../../helpers'
import { CloseCircleFilled } from '@ant-design/icons'
import { getClassNames } from '../../../../_utils/classnames'
import { useJourneyContext } from '../../context'
import { preventAll } from '../../../../_utils/utils'
import { JourneyNode, JourneyStep } from '../../types/journey-nodes'
import { JourneyAction } from '../../types/journey-context'
import { StepType } from '@pushly/models/lib/enums/journeys'
import { JourneyBuilderMode } from '../../enums'

export const JourneyNodeIcon = ({ id, node }: { id: string; node: JourneyStep }) => {
    const [state, dispatch] = useJourneyContext()
    const { getNode, getNodes, getEdges, setEdges, setNodes } = useReactFlow<JourneyNode>()
    const icon = getStepConfig(node)?.icon

    const handleRemoveNode: MouseEventHandler<HTMLSpanElement> = useCallback(
        (ev) => {
            preventAll(ev)

            const nodeToRemove = getNode(id)!
            const [nodeChanges, edgeChanges] = getRemoveNodeMutations(nodeToRemove, getNodes(), getEdges())
            dispatch({ action: JourneyAction.ON_NODE_REMOVE, data: nodeToRemove })

            setEdges((eds) => applyEdgeChanges(edgeChanges, eds))
            setNodes((nodes) => applyNodeChanges(nodeChanges, nodes))
        },
        [id],
    )

    return (
        <div
            className={getClassNames(null, 'icon', {
                readonly: state.mode === JourneyBuilderMode.READONLY,
            })}
        >
            {node.type !== StepType.TRIGGER && node.type !== StepType.EXIT && (
                <CloseCircleFilled className="journey-node-removal-button" onClick={handleRemoveNode} />
            )}
            <span
                className={getClassNames(null, 'journey-node-icon', {
                    'no-action': [StepType.TRIGGER, StepType.EXIT].includes(node.type),
                })}
            >
                {icon}
            </span>
        </div>
    )
}
